import React, { useState, useEffect } from 'react'
import './App.css';
import 'worldwindjs'
import Globe from 'worldwind-react-globe'
import EarthHeader from './comps/EarthHeader';
import ShipListDrawer from './comps/ships/ShipListDrawer';
import ShipsLayer from './comps/ships/ShipsLayer'
import PlaneListDrawer from './comps/planes/PlaneListDrawer'
import PlanesLayer from './comps/planes/PlanesLayer'
import EventListDrawer from './comps/events/EventListDrawer'
import EventsLayer from './comps/events/EventsLayer'
import PersonListDrawer from './comps/person/PersonListDrawer'
import PeopleLayer from './comps/person/PeopleLayer'
import TargetsLayer from './comps/targets/TargetsLayer'
import PersonAddModal from './comps/person/PersonAddModal'
import RenderablesLayer from './comps/RenderablesLayer'
import TargetListDrawer from './comps/targets/TargetsListDrawer';
import Login from './comps/login'
import useToken from './comps/useToken';

const App = () => {
  const { token, setToken } = useToken();

  const [keyword, setKeyword] = useState("")
  const [globe, setGlobe] = useState(null)

  const [isPlaneDrawerShow, setIsPlaneDrawerShow] = useState(false)
  const [isShipDrawerShow, setIsShipDrawerShow] = useState(false)
  const [isEventDrawerShow, setIsEventDrawerShow] = useState(false)
  const [isTargetDrawerShow, setIsTargetDrawerShow] = useState(false)
  const [isPersonDrawerShow, setIsPersonDrawerShow] = useState(false)
  const [isPersonAddModalOpen, setIsPersonAddModalOpen] = useState(false)

  const [ships, setShips] = useState([])
  const [planes, setPlanes] = useState([])
  const [events, setEvents] = useState([])
  const [people, setPeople] = useState([])
  const [targets, setTargets] = useState([])

  const [filteredShips, setFilteredShips] = useState([])
  const [filteredPlanes, setFilteredPlanes] = useState([])
  const [filteredEvents, setFilteredEvents] = useState([])
  const [filteredPeople, setFilteredPeople] = useState([])
  const [filteredTargets, setFilteredTargets] = useState([])

  const [shipTypes, setShipTypes] = useState({})
  const [combinedItems, setCombinedItems] = useState([])

  const globeRef = React.createRef()
  let nextMarkerId = 1;

  useEffect(() => {
    setGlobe(globeRef.current)
  }, [globeRef])

  useEffect(() => {
    combineItems()
  }, [ships.length, planes.length, targets.length, people.length, events.length])

  const addShip = (marker, ship)=> {
    // Ensure each marker has a unique ID
    if (!marker.uniqueId) {
        marker.uniqueId = nextMarkerId++
    }
    // Create a new array from the previous array + marker
    ships.push({marker:marker, ship:ship})
    setShips(ships)
    filteredShips.push({marker:marker, ship:ship})
    setFilteredShips(filteredShips)
    var currentTypes = shipTypes
    // if ("潜艇||航母||巡洋舰||驱逐舰".includes(ship.type)){
    //   currentTypes[ship.type] = true
    // }else{
    //   currentTypes[ship.type] = false
    // }    
    currentTypes[ship.type] = true
    setShipTypes(currentTypes)
  }

  const addPlane = (marker, plane)=>{
    // Ensure each marker has a unique ID
    if (!marker.uniqueId) {
      marker.uniqueId = nextMarkerId++
    }
    // Create a new array from the previous array + marker
    planes.push({marker:marker, plane:plane})
    setPlanes(planes)
    filteredPlanes.push({marker:marker, plane:plane})
    setFilteredPlanes(filteredPlanes)
  }

  const addEvent = (marker, event)=>{
    // Ensure each marker has a unique ID
    if (!marker.uniqueId) {
      marker.uniqueId = nextMarkerId++
    }
    // Create a new array from the previous array + marker
    events.push({marker:marker, event:event})
    setEvents(events)
    filteredEvents.push({marker:marker, event:event})
    setFilteredEvents(filteredEvents)
  }

  const addPerson = (person) => {
    // Create a new array from the previous array
    people.push(person)
    setPeople(people)
    filteredPeople.push(person)
    setFilteredPeople(filteredPeople)
  }

  const addTarget = (marker, target)=>{
    // Ensure each marker has a unique ID
    if (!marker.uniqueId) {
      marker.uniqueId = nextMarkerId++
    }
    // Create a new array from the previous array + marker
    targets.push({marker:marker, target:target})
    setTargets(targets)
    filteredTargets.push({marker:marker, target:target})
    setFilteredTargets(targets)
  }

  const handleAddModalShow = ()=>{
    setIsPersonAddModalOpen(!isPersonAddModalOpen)
  }

  const handleShipDrawerShow = ()=>{
    setIsShipDrawerShow(!isShipDrawerShow)
    setIsPlaneDrawerShow(false)
    setIsEventDrawerShow(false)
    setIsPersonDrawerShow(false)
    setIsTargetDrawerShow(false)
  }

  const handlePlaneDrawerShow = ()=>{
    setIsShipDrawerShow(false)
    setIsPlaneDrawerShow(!isPlaneDrawerShow)
    setIsEventDrawerShow(false)
    setIsPersonDrawerShow(false)
    setIsTargetDrawerShow(false)
  }

  const handleEventDrawerShow = ()=>{
    setIsShipDrawerShow(false)
    setIsPlaneDrawerShow(false)
    setIsEventDrawerShow(!isEventDrawerShow)
    setIsPersonDrawerShow(false)
    setIsTargetDrawerShow(false)
  }

  const handlePersonDrawerShow = ()=>{
    setIsShipDrawerShow(false)
    setIsPlaneDrawerShow(false)
    setIsEventDrawerShow(false)
    setIsPersonDrawerShow(!isPersonDrawerShow)
    setIsTargetDrawerShow(false)
  }

  const handleTargetDrawerShow = () => {
    setIsShipDrawerShow(false)
    setIsPlaneDrawerShow(false)
    setIsEventDrawerShow(false)
    setIsPersonDrawerShow(false)
    setIsTargetDrawerShow(!isTargetDrawerShow)
  }

  const handleCheck = (event)=>{
    var currentTypes = shipTypes
    currentTypes[event.target.value] = event.target.checked
    setShipTypes(currentTypes)
    setFilteredShips(ships.filter((ship)=>{
      return ship.marker.label.toUpperCase().includes(keyword.toString().toUpperCase()) && shipTypes[ship.ship.type]
    }))
  }

  const handleShipFilter = (event)=>{
      event.preventDefault()
      const {keyCode,target} = event
      setKeyword(target.value)
      if (keyCode !== 13){
          return
      } else{          
        setFilteredShips(ships)
        setFilteredShips(ships.filter((ship)=>{
          return ship.ship.shipName.includes(keyword.toString().toUpperCase()) && shipTypes[ship.ship.type]
        }))
      }
  }

  const handlePlaneFilter = (event)=>{
    event.preventDefault()
    const {keyCode,target} = event
    setKeyword(target.value)
    if (keyCode !== 13){
        return
    } else{    
      setFilteredPlanes(planes.filter((plane)=>{
        return (plane.plane.reg +"||"+ plane.plane.icao +"||"+ plane.plane.type ).toUpperCase().includes(keyword.toString().toUpperCase())
      }))
    }
  }

  const handleEventFilter = (event)=>{
      event.preventDefault()
      const {keyCode,target} = event
      setKeyword(target.value)
      if (keyCode !== 13){
          return
      } else{    
        setFilteredEvents(events.filter((event)=>{
          return event.event.text.includes(keyword.toString().toUpperCase())
        }))
      }
  }

  const handlePersonFilter = (event)=>{
    event.preventDefault()
    const {keyCode,target} = event
    setKeyword(target.value)
    if (keyCode !== 13){
        return
    } else{    
      setFilteredPeople(people.filter((person)=>{
        return person.cn_name.includes(keyword) || person.en_name.toUpperCase().includes(keyword.toString().toUpperCase())
      }))
    }
  }

  const handleTargetFilter = (event)=>{
    event.preventDefault()
    const { keyCode, target } = event
    setKeyword(target.value)
    if (keyCode !== 13){
        return
    } else{    
      setFilteredTargets(targets.filter((target)=>{
        return target.target.chnName.includes(keyword) || target.target.engName.toUpperCase().includes(keyword.toString().toUpperCase())
      }))
    }
  }

  const combineItems = () => {
    let result = []
    if (ships.length > 0) {
      ships.forEach((item) => {
        if (shipTypes[item.ship.type]) {
          result.push({
            ...item,
            value: item.ship.shipName,
            label: item.ship.shipName,
            type: 'ship'
          })
        }
      })
    }
    if (planes.length > 0) {
      planes.forEach((item) => {
        result.push({
          ...item,
          value: `${item.plane.reg} ${item.plane.icao} ${item.plane.type}`,
          label: `${item.plane.reg} ${item.plane.icao} ${item.plane.type}`,
          type: 'plane'
        })
      })
    }
    if (events.length > 0) {
      events.forEach((item) => {
        result.push({
          ...item,
          value: item.event.text,
          label: item.event.text,
          type: 'event'
        })
      })
    }
    if (people.length > 0) {
      people.forEach((item) => {
        result.push({
          ...item,
          value: `${item.cn_name} ${item.en_name}`,
          label: `${item.cn_name} ${item.en_name}`,
          type: 'people'
        })
      })
    }
    if (targets.length > 0) {
      targets.forEach((item) => {
        result.push({
          ...item,
          value: `${item.target.chnName} ${item.target.engName}`,
          label: `${item.target.chnName} ${item.target.engName}`,
          type: 'target'
        })
      })
    }
    setCombinedItems(result)
  }

  const layers = [
    {layer: 'bing-aerial', options: {category: 'base', enabled: true}},
    {layer: 'renderables', options: {category: 'data', enabled: true, displayName: 'Markers'}},
    {layer: 'compass', options: {category: 'setting', enabled: false}},
    {layer: 'coordinates', options: {category: 'setting', enabled: true}},
    {layer: 'view-controls', options: {category: 'setting', enabled: true}},
    {layer: 'stars', options: {category: 'setting', enabled: true}},
    {layer: 'atmosphere-day-night', options: {category: 'setting', enabled: true}},
  ]
  return (
      <div>
        {
          token && token !== 'null' ? 
          <>
            <div  className='fullscreen'>              
              <div className='globe'>
                <Globe 
                  ref={globeRef} 
                  layers={layers}
                  latitude={20}
                  longitude={120}
                  altitude={10e6}/>        
                <ShipListDrawer globe={globe} isShipDrawerShow={isShipDrawerShow} handleShipDrawerShow={handleShipDrawerShow}
                    shipTypes={shipTypes} handleCheck={handleCheck} handleFilter={handleShipFilter} filteredShips={filteredShips}></ShipListDrawer>
                <ShipsLayer globe={globe} markersLayerName="Markers" addShip={addShip}/>
                <PlaneListDrawer globe={globe} isPlaneDrawerShow={isPlaneDrawerShow} handlePlaneDrawerShow={handlePlaneDrawerShow}
                    handleFilter={handlePlaneFilter} filteredPlanes={filteredPlanes} />
                <PlanesLayer globe={globe} markersLayerName="Markers" addPlane={addPlane}/>
                <EventListDrawer globe={globe} isEventDrawerShow={isEventDrawerShow} handleEventDrawerShow={handleEventDrawerShow}
                    handleFilter={handleEventFilter} filteredEvents={filteredEvents} />
                <EventsLayer globe={globe} markersLayerName="Markers" addEvent={addEvent}/>
                <PersonListDrawer isPersonDrawerShow={isPersonDrawerShow} handlePersonDrawerShow={handlePersonDrawerShow} handleAddModalShow={handleAddModalShow}
                    handleFilter={handlePersonFilter} filteredPeople={filteredPeople} />
                <PeopleLayer addPerson={addPerson}/>
                <TargetListDrawer globe={globe} isTargetDrawerShow={isTargetDrawerShow} handleTargetDrawerShow={handleTargetDrawerShow}
                    handleFilter={handleTargetFilter} filteredTargets={filteredTargets}/>
                <TargetsLayer globe={globe} markersLayerName="Markers" addTarget={addTarget}/>
                <RenderablesLayer globe={globe} planes={planes} ships={ships} events={events} targets={targets}/>
              </div>
              <EarthHeader
                handleShipDrawerShow={handleShipDrawerShow}
                handlePlaneDrawerShow={handlePlaneDrawerShow}
                handleEventDrawerShow={handleEventDrawerShow}
                handlePersonDrawerShow={handlePersonDrawerShow}
                handleTargetDrawerShow={handleTargetDrawerShow}
                combinedItems={combinedItems}
                setToken={setToken}
              />
              <PersonAddModal isModalOpen={isPersonAddModalOpen} handleModalShow={handleAddModalShow}/>
             </div>
          </>
          : <Login setToken={setToken} />
        }
      </div>
    )
}  

export default App